module.exports = __webpack_public_path__ + "img/OurJourney2020.afe85fde.png";